import cx from 'classnames';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export const EndAdornment = ({ className, children }: Props): JSX.Element => {
  return <span className={cx(className, 'block ml-4')}>{children}</span>;
};
